import { DetentionDefinitionTable } from "../DetentionDefinitionTable";
import { DataSource, Layout, LayoutHeader } from "@mcleod/components";

export abstract class AutogenLayoutDetentionDefinitionList extends Layout {
    layoutDetentionDefinitionTable: DetentionDefinitionTable;
    layoutheaderDetentionDefinitionList: LayoutHeader;
    sourceDetentionDef: DataSource;
}
